/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// GA Events Code Push on Click Product Cards Collection Page
document.addEventListener('DOMContentLoaded', function () {
  const loadingGif = document.querySelector(".pagination");
  let collectionItems = document.getElementsByClassName("product-card");

  const handleClick = function () {
    const productName = this.getAttribute("data-product-name");
    const productId = this.getAttribute("data-product-id");
    const productVendor = this.getAttribute("data-product-vendor");
    const productVariant = this.getAttribute("data-product-variant");
    const productPrice = this.getAttribute("data-product-price");
    const productCollection = this.getAttribute("data-product-collection");
    const CollectionId = this.getAttribute("data-collection-id");
    const indexNumber = this.getAttribute("product-index-number");

    dataLayer.push({
      event: "select_item",
      ecommerce: {
        items: [
          {
            item_id: productId,
            item_name: productName,
            index: indexNumber,
            item_brand: productVendor,
            item_list_id: CollectionId,
            item_list_name: productCollection,
            item_variant: productVariant,
            price: productPrice,
            quantity: 1
          }
        ]
      }
    });
  };

  const attachEventListeners = () => {
    Array.from(collectionItems).forEach(function (element) {
      element.addEventListener("click", handleClick);
    });
  };

  const removeEventListeners = () => {
    Array.from(collectionItems).forEach(function (element) {
      element.removeEventListener("click", handleClick);
    });
  };

  const intersectionCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // When the loading-gif is in view, remove the event listeners and return
        removeEventListeners();
        return;
      }
      // When the loading-gif is not in view, attach the event listeners to ProductItem elements
      attachEventListeners();
    });
  };

  // Start observing the loading-gif element
  const observer = new IntersectionObserver(intersectionCallback);
  observer.observe(loadingGif);
});


// Create an Intersection Observer object
const options = {
  root: null, // viewport
  rootMargin: '0px', // margin around the viewport
  threshold: 0.5, // percentage of the target element that needs to be visible
};

const observer = new IntersectionObserver(callback, options);
let observedProductCards = [];

// Define the callback function
function callback(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // Element is in the viewport
      const productItem = entry.target;

      // Extract data from the product-item element (customize this part)
      const productId = productItem.getAttribute('data-product-id');
      const productName = productItem.getAttribute('data-product-name');
      const productPrice = productItem.getAttribute('data-product-price');
      const productVendor = productItem.getAttribute('data-product-vendor');
      const productVariant = productItem.getAttribute('data-product-variant');
      const productCollection = productItem.getAttribute('data-product-collection');
      const CollectionId = productItem.getAttribute('data-collection-id');
      const indexNumber = productItem.getAttribute('product-index-number');

      observedProductCards.push({
        item_id: productId,
        item_name: productName,
        index: indexNumber,
        item_brand: productVendor,
        item_list_id: CollectionId,
        item_list_name: productCollection,
        item_variant: productVariant,
        price: productPrice,
        quantity: 1,
      });

      if (observedProductCards.length >= 4) {
        // Push the data into the dataLayer for a group of 4 product cards
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'view_item_list',
          ecommerce: {
            items: observedProductCards,
          },
        });

        // Clear the observed product cards array
        observedProductCards = [];
      }

      // Unobserve the target element
      observer.unobserve(productItem);
    }
  });
}

// Observe all elements with the class [product-item]
const productItems = document.querySelectorAll('.product-card');
productItems.forEach(productItem => {
  observer.observe(productItem);
});
